import { getTextColorTextButtons, getTextHighlightTextButtons } from './getTextButtons.js';
import { tiptapColorBackgroundExtension } from './tiptap-background.js';
import { tiptapColorForegroundExtension } from './tiptap-foreground.js';
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from './types.js';
import 'ricos-types';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import './constants.js';
import './dataHooks.js';
import './icons/TextColorIcon.js';
import 'react';
import './icons/TextHighlightIcon.js';
import './TextColorPicker.js';
import 'ricos-context';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import 'immutable';
import 'ricos-schema/dist/statics/color.defaults.json';
import 'wix-rich-content-plugin-commons';

const pluginTextColor = (config = {}) => {
  return {
    config,
    type: TEXT_COLOR_TYPE,
    // @todo: next-major: move tiptapColorBackgroundExtension to pluginTextHighlight
    tiptapExtensions: [tiptapColorBackgroundExtension, tiptapColorForegroundExtension],
    textButtons: getTextColorTextButtons(config)
  };
};
const pluginTextHighlight = (config = {}) => {
  return {
    config,
    type: TEXT_HIGHLIGHT_TYPE,
    //tiptapExtensions: [tiptapColorBackgroundExtension],
    textButtons: getTextHighlightTextButtons(config)
  };
};

export { pluginTextColor, pluginTextHighlight };
//# sourceMappingURL=editor.js.map
